module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('h2', {
    staticClass: "h2c",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10"
    }
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("CHAPTER 1")])])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10"
    }
  }, [_c('h2', {
    staticClass: "h2c1"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("MATERIALS")]), _c('br'), _c('span', {
    staticClass: "c2"
  }, [_vm._v("&Tools")])])]), _c('div', {
    staticClass: "land80"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0010-01",
      "src": "images/f0010-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11"
    }
  }), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "lev1"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12"
    }
  }, [_vm._v("Soap for Carving")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("You don’t need to purchase special soap for carving. You can use commercially made soap that’s typically sold in supermarkets, pharmacies, and other retailers. Regardless of the brand or type you use, make sure it’s fresh, soft, and moist, because hard, dried-out soap is difficult to carve properly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keep these recommendations in mind when choosing soap for carving:")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Texture.")]), _vm._v(" The soap should be soft, moist, smooth, and fine. Don’t use exfoliating soaps.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Shape.")]), _vm._v(" Choose soaps that are large and thick so they’re easier to carve. I use 3-ounce (85-gram) or 5-ounce (142-gram) bars.")])]), _c('p', {
    staticClass: "blist"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12"
    }
  }, [_vm._v("• "), _c('strong', [_vm._v("Color.")]), _vm._v(" Colored soap is great for carving. Color can enhance a design and emphasize the details in a carved pattern. If your choice of colors is limited, or if you want to customize your designs, you can apply color to carved soap (see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch2#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(" for details).")]), _vm._v(" "), _c('aside', {
    staticClass: "sidebar",
    attrs: {
      "epub:type": "sidebar"
    }
  }, [_c('p', {
    staticClass: "sideh",
    attrs: {
      "id": "slev3a"
    }
  }, [_vm._v("STORING SOAP")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "ft50"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0012-01",
      "src": "images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt"
  }, [_c('strong', [_vm._v("As a general rule, you should purchase soap for carving that’s well-packaged; ideally, it should be sealed in plastic. To keep soap from drying out, leave it in its original packaging until you’re ready to carve it.")])])]), _vm._v(" "), _c('p', {
    staticClass: "sidetxt"
  }, [_c('strong', [_vm._v("You can wrap loose soaps (including original packaged soaps) in plastic wrap, then store them in a resealable plastic bag or a covered plastic container. To help keep the soaps from drying out, add a tiny bit of water to the bag or container. You can also use this storage method for small pieces of soap that accumulate during carving.")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a",
    attrs: {
      "id": "blev46"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13"
    }
  }, [_vm._v("TYPES OF SOAP")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In addition to basic commercially made opaque soap that’s usually used for carving, there are a few other options to be aware of.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• Once you’ve gained some carving experience, you might want to try working with "), _c('strong', [_vm._v("transparent")]), _vm._v(" or "), _c('strong', [_vm._v("glycerin soap.")]), _vm._v(" Transparent soap is beautiful, but it’s hard to carve because it’s very sticky, as the glycerin is a humectant, which retains moisture. But, if you make a mistake, transparent soap is easy to melt and harden; though it will be more white than the original soap. Note that "), _c('strong', [_vm._v("handmade melt-and-pour soap")]), _vm._v(" is very similar to transparent soap in terms of handling.")])]), _c('p', {
    staticClass: "blist"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13"
    }
  }, [_vm._v("• Handmade cold-process soap and handmade hot-process soap can be used for carving, but both types are often dry and hard. After they’re made, these soaps are usually air dried for long periods in order to evaporate the liquid ingredients so the bars won’t soften or melt. If you want to try carving handmade soap, shop for fresh bars, which will likely be softer, or you can soften it before carving (see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch2#page_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• Typically, soap made locally within your country or region will be fresher than imported soap.")]), _vm._v(" "), _c('div', {
    staticClass: "land100"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0013-01",
      "src": "images/f0013-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "lev2"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14"
    }
  }, [_vm._v("Tools for Carving Soap")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('h4', {
    staticClass: "h4a",
    attrs: {
      "id": "blev1"
    }
  }, [_vm._v("CARVING KNIVES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are two types of carving knives, which are distinguished by the shape of the blade.")])]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Bird’s beak knife.")]), _vm._v(" This type of knife has a curved spine and a long cutting edge like a bird’s beak. The blade of the bird’s beak knife is often made of stainless steel. The handle is often constructed of plastic or wood, which makes the bird’s beak knife lightweight.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Classic carving knife.")]), _vm._v(" This type of knife has a long V-shaped blade and is the kind traditionally used in Thai carving. The cutting edge is usually one side of the blade. The blade of the classic knife is steel or stainless steel. Steel blades are usually very thin and flexible (though very thin stainless steel blades are available, too). The handle of the classic knife is made of aluminum, stainless steel, brass, or wood. An aluminum or wood handle is lightweight. Professional carving artists often use the classic carving knife with a flexible blade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You can choose either the bird’s beak knife or the classic carving knife for the projects in this book. I prefer the bird’s beak knife, which is what you’ll see throughout the project photos.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Purchasing and Caring for Your Knife")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Regardless of whether you choose the bird’s beak or the classic knife design, there are many sorts of blades available, and there are differences in the thickness and length of the blade. Generally, cheaper knives tend to have thicker blades, while knives with thin blades are more expensive. You can find a large selection of carving knives online; unfortunately, they are seldom sold at retail stores.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Classic carving knives were originally used for carving fruits or vegetables such as watermelons, honeydew melons, and pumpkins, so I think the blade of the carving knife is too long to carve small soap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The length of the blade for both the bird’s beak knife and the classic carving knife is usually 1"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("4")]), _vm._v("\" to 2\" (4.5 cm to 5 cm). A carving knife with a blade of more than 2\" (5 cm) is not recommended for soap carving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Note that you can probably do very simple soap carving with a craft knife (the type used with paper). However, compared to using a carving knife, it’s very exhausting to carve more complicated projects with a craft knife.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land100"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0014-01",
      "src": "images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Bird’s beak and classic carving knives.")])])])]), _c('aside', {
    staticClass: "sidebar",
    attrs: {
      "epub:type": "sidebar"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "sideh",
    attrs: {
      "id": "slev1"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15"
    }
  }, [_vm._v("CARVING SOAP WITH KIDS: SAFETY TIPS")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "sidetxt"
  }, [_c('strong', [_vm._v("Soap carving is a craft that kids will enjoy, and can even use for school projects. Soap is soft, so it’s much easier and safer to carve than wood or stone. However, a carving knife is very sharp, so you’ll need to follow some guidelines for carving soap with kids.")])]), _vm._v(" "), _c('p', {
    staticClass: "sblist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Adult supervision required. Any time a child uses a sharp object, adult supervision is required. There are recommended carving knife alternatives listed below, but they should only be used in the presence of an adult.")])]), _vm._v(" "), _c('p', {
    staticClass: "sblist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Use soft soap. It’s very dangerous for anyone, especially children, to carve hard soap. Carving hard soap could cause the carving knife to easily slip, resulting in an injury. Even when working with soft soap, to avoid injury be mindful not to hold the soap near where you’re planning to carve it.")])]), _vm._v(" "), _c('p', {
    staticClass: "sblist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Use a carving knife for kids. As an alternative to a classic carving knife, you can purchase a kid’s carving knife, whose blade isn’t as sharp. These knives can be found online.")])]), _vm._v(" "), _c('p', {
    staticClass: "sblist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Use a craft knife. Simple soap carving projects can be done with a craft or hobby knife instead of the carving knife. These are easy to find in most craft stores. Note that a utility knife is not recommended because the blade could snap off during carving.")])]), _vm._v(" "), _c('p', {
    staticClass: "sblist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Wear safety gloves. For additional safety, kids should wear a safety glove on the hand they use to hold the soap as they carve (usually their nondominant hand).")])]), _vm._v(" "), _c('p', {
    staticClass: "sblist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Store knives securely. Always keep carving knives out of reach of small children and pets. "), _c('em', [_vm._v("Note:")]), _vm._v(" As with all knives, be sure to keep the knives you use for your soap carving—as well as any additional sharp tools—out of the reach of children.")])]), _vm._v(" "), _c('div', {
    staticClass: "land70"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0015-01",
      "src": "images/f0015-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("If you’re working with a knife that’s a bit longer than you’d like, you might try wrapping the base of the blade with a strip of sheet metal, fabric, or tissue paper to protect your fingers. Alternatively, you can shorten a steel blade a bit with a metal file. (A stainless-steel blade will be too hard to shorten.)")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("How to Sharpen a Dull Carving Knife")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can use 1,000- to 2,000-grit sandpaper to sharpen your carving knife when it becomes dull. First, wet the sandpaper with water and then place it on the edge of a flat work surface. Put the knife blade on the sandpaper and move the knife to the knife spine. Repeat as needed on both sides of the blade. Apply some oil to the knife blade to keep it from rusting if stored for a long time.")])])]), _c('div', {
    staticClass: "groupa"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15"
    }
  }), _c('h4', {
    staticClass: "h4a",
    attrs: {
      "id": "lev3"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16"
    }
  }, [_vm._v("ADDITIONAL CARVING TOOLS")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In addition to the knife you’ll use to do most of your carving, you’ll need the following tools:")])])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "blist",
    attrs: {
      "id": "plev1"
    }
  }, [_vm._v("• "), _c('strong', [_vm._v("Paring knife.")]), _vm._v(" The paring knife is used to cut the soap roughly (such as when you’re cutting out a basic outline) or to slice the soap in half horizontally. You can use a common paring knife.")]), _vm._v(" "), _c('div', {
    staticClass: "land100"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0016-01",
      "src": "images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Paring knives")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "blist",
    attrs: {
      "id": "blev1a"
    }
  }, [_vm._v("• "), _c('strong', [_vm._v("Carving gouges.")]), _vm._v(" Carving gouges are used to carve curling petals. You’ll be amazed at how easy it is to carve realistic petals with carving gouges. These gouges are sold in sets; the V-tool and U-gouge are often used for soap carving, and there is also a W-tool for carving a wavy petal.")]), _vm._v(" "), _c('div', {
    staticClass: "land100"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0016-02",
      "src": "images/f0016-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Carving gouges")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "blist",
    attrs: {
      "id": "blev2a"
    }
  }, [_vm._v("• "), _c('strong', [_vm._v("Sculpting tool.")]), _vm._v(" A sculpting tool is used to scrape inside the soap or flatten it. It is often used for soap cutwork. You can use a small spoon, such as a teaspoon, a wax carving spatula, or a metal ear pick instead of a sculpting tool.")]), _vm._v(" "), _c('div', {
    staticClass: "land100"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0016-03",
      "src": "images/f0016-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Sculpting tools")])])])]), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "lev4"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17"
    }
  }, [_vm._v("Other Supplies")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Toothpicks.")]), _vm._v(" Toothpicks are used for drawing outlines on the soap or making small holes in the soap.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Cookie cutters.")]), _vm._v(" You can cut out the soap into fancy shapes using cookie cutters. It’s easier than cutting with a carving knife. And you can cut a circle for the center bud using a circle cookie cutter on the top of the soap.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Pins.")]), _vm._v(" You can use pins to make small holes in the soap. And when you trace the template into the soap, you’ll use pins to attach the template.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Craft glue, adhesive, or hot glue gun.")]), _vm._v(" If you’re planning on displaying your carved soap rather than using it, you can use craft glue or adhesive for adding decorations such as beads. And if a piece of soap accidentally breaks off while you’re carving, you can reattach the broken piece with glue to fix it. Any craft glue or adhesive sold for use with paper, fabric, or wood will work.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Awl.")]), _vm._v(" You’ll need an awl to make small and long holes such as a hole for a stem in a flower bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Cutting board.")]), _vm._v(" When you cut the soap with a paring knife, a cutting board will protect your work surface.")]), _vm._v(" "), _c('div', {
    staticClass: "land100"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0017-01",
      "src": "images/f0017-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1df5fbfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch1.vue
// module id = 72
// module chunks = 0